<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_v" title="v">FOR SEAN, MY BEST FRIEND,</span></p>
<p class="Dedication-ded">TRUE LOVE, AND PARTNER IN CRIME</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?eea26b02